import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons";
import "./RatingStar.scss";

export const RatingStar = ({
  defaultValue = -1,
  precision = 1,
  totalStars = 5,
  emptyIcon = faStarSolid,
  filledIcon = faStarSolid,
  iconSize = "lg",
  onChange = () => {},
  ...props
}) => {
  const [activeStar, setActiveStar] = useState(defaultValue);
  const [hoverActiveStar, setHoverActiveStar] = useState(-1);
  const [isHovered, setIsHovered] = useState(false);
  const ratingContainerRef = useRef(null);

  const calculateRating = (e) => {
    const { width, left } = ratingContainerRef.current.getBoundingClientRect();
    let percent = (e.clientX - left) / width;
    const numberInStars = percent * totalStars;
    const nearestNumber = Math.round((numberInStars + precision / 2) / precision) * precision;

    return Number(nearestNumber.toFixed(precision.toString().split(".")[1]?.length || 0));
  };

  const handleClick = (e) => {
    setIsHovered(false);
    setActiveStar(calculateRating(e));
    onChange(calculateRating(e));
  };

  const handleMouseMove = (e) => {
    setIsHovered(true);
    setHoverActiveStar(calculateRating(e));
  };

  const handleMouseLeave = (e) => {
    setHoverActiveStar(-1); // Reset to default state
    setIsHovered(false);
  };

  return (
    <div
      className={`rating-star ${props.className ?? ""}`}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      ref={ratingContainerRef}
      style={{ ...props.style }}
    >
      {[...new Array(totalStars)].map((_, index) => {
        const activeState = isHovered ? hoverActiveStar : activeStar;

        const showEmptyIcon = activeState === -1 || activeState < index + 1;

        const isActiveRating = activeState !== 1;
        const isRatingWithPrecision = activeState % 1 !== 0;
        const isRatingEqualToIndex = Math.ceil(activeState) === index + 1;
        const showRatingWithPrecision =
          isActiveRating && isRatingWithPrecision && isRatingEqualToIndex;

        return (
          <div role="button" className="star position-relative" key={index}>
            <div
              className="position-absolute overflow-hidden"
              style={{ width: showRatingWithPrecision ? `${(activeState % 1) * 100}%` : "0%" }}
            >
              <FontAwesomeIcon icon={filledIcon} size={iconSize} color="#FFBB28" />
            </div>

            <div style={{ color: showEmptyIcon ? "#E7E7E9" : "#FFBB28" }}>
              <FontAwesomeIcon icon={showEmptyIcon ? emptyIcon : filledIcon} size={iconSize} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RatingStar;
